import { Link } from "react-router-dom";
import { Logo, NAV_LINKS } from "./Nav";
import SectionLink from "./SectionLink";
import { SITE } from "../../seo/site";
import { SERVICE_LINKS, COMPANY_LINKS } from "../../content/siteLinks";

const linkClass = "text-[13px] text-ivory/70 hover:text-ivory transition-colors duration-300";

const FOOTER_EXPLORE_LINKS = [...NAV_LINKS, { label: "FAQ", id: "faq" }];

const FooterColumn = ({ heading, children }) => (
  <div>
    <p className="text-[10px] uppercase tracking-[0.3em] font-semibold text-ivory/40 mb-5">{heading}</p>
    <ul className="flex flex-col gap-3">{children}</ul>
  </div>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy border-t border-ivory/10 text-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr_1fr]">
        <div className="max-w-sm">
          <Logo light />
          <p className="mt-6 text-sm leading-relaxed text-ivory/60">
            Doctor-led formulation and product development for beauty, wellness and Ayurvedic brands — from first idea to market-ready product.
          </p>
          <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="mt-4 inline-block text-sm text-ivory/80 hover:text-ivory transition-colors duration-300">
            {SITE.email}
          </a>
        </div>

        <FooterColumn heading="Explore">
          {FOOTER_EXPLORE_LINKS.map(({ label, id }) => (
            <li key={id}>
              <SectionLink id={id} data-testid={`footer-link-${id}`} className={linkClass}>{label}</SectionLink>
            </li>
          ))}
        </FooterColumn>

        <FooterColumn heading="Formulation Services">
          {SERVICE_LINKS.map(({ label, path }) => (
            <li key={path}>
              <Link to={path} data-testid={`footer-service-link-${path.slice(1)}`} className={linkClass}>{label}</Link>
            </li>
          ))}
        </FooterColumn>

        <FooterColumn heading="Company">
          {COMPANY_LINKS.map(({ label, path }) => (
            <li key={path}>
              <Link to={path} data-testid={`footer-company-link-${path === "/" ? "home" : path.slice(1)}`} className={linkClass}>{label}</Link>
            </li>
          ))}
        </FooterColumn>
      </div>
      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row gap-3 justify-between text-[12px] text-ivory/50">
          <span>© {new Date().getFullYear()} The Formulation House. All rights reserved.</span>
          <span className="flex gap-6">
            <span className="cursor-default">Privacy Policy</span>
            <span className="cursor-default">Terms of Service</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
